function getConfigFromHtml() {
  const appConfigTag = window.document.getElementById("app-config");
  if (appConfigTag) {
    return JSON.parse(appConfigTag.innerText);
  }
}

export default getConfigFromHtml();
